import styled from 'styled-components'

export const StyledItemsContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 4px;
  max-height: calc(100% - 220px);
  overflow: auto;
`

export const StyledItemContainer = styled.div`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #D4D4D6;
  margin-bottom: 24px;
  & > div img {
    height: 120px;
  } 
  & > div h3 {
    font-weight: 600;
  } 
`
